var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreachRiskCloudIntegrations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1313.002 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M83.752,133.351A136.584,136.584,0,0,1,55.1,136.8q-12.751,0-20.4-3.15a25.148,25.148,0,0,1-12-10.049,44.626,44.626,0,0,1-6-16.2A137.47,137.47,0,0,1,15.052,84q0-29.548,8.325-41.175T54.052,31.2q12.9,0,29.85,4.05l-.6,16.5A170.376,170.376,0,0,0,58.627,49.5Q48.8,49.5,44.6,52.125T38.377,62.1q-2.025,7.35-2.025,25.049t4.125,24.525q4.124,6.828,16.5,6.825A176.966,176.966,0,0,0,83.3,116.4Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.856,135H94.222V63.6h14.489V122.19h26.145Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.453,127.388q-6.669,8.874-22.942,8.872t-22.943-8.872q-6.669-8.871-6.667-27.773t6.667-28.088q6.667-9.186,22.943-9.187t22.942,9.187q6.667,9.191,6.668,28.088T190.453,127.388Zm-34.545-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479t-3.15-18.848q-3.15-5.88-11.55-5.88t-11.55,5.88q-3.15,5.882-3.15,18.848T155.908,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.27,111.165q0,12.5,12.7,12.495t12.705-12.495V63.6h14.489v47.25q0,13.127-6.772,19.267t-20.422,6.142q-13.651,0-20.423-6.142t-6.772-19.267V63.6h14.49Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.024,135H273.979V63.6h24.045a50.19,50.19,0,0,1,15.225,1.942,18.17,18.17,0,0,1,9.293,6.4,26.474,26.474,0,0,1,4.567,10.5,79.45,79.45,0,0,1,1.26,15.7,92.052,92.052,0,0,1-1.155,16.012,31.025,31.025,0,0,1-4.358,11.34,18.159,18.159,0,0,1-9.292,7.245Q307.472,135,298.024,135Zm15.225-28.35q.21-3.359.21-9.293a85.363,85.363,0,0,0-.42-9.5,18.166,18.166,0,0,0-2-6.509,8.305,8.305,0,0,0-4.672-4.043,25.583,25.583,0,0,0-8.348-1.1h-9.555v46.2h9.555q7.875,0,11.445-3.99Q312.514,115.157,313.249,106.65Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,135V33h20.7V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.765,135V63.6h24.464l17.221,58.8h1.05V63.6h14.49V135H442.155l-17.85-58.8h-1.051V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.024,76.41V63.6h52.5V76.41h-18.9V135h-14.49V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.558,135V63.6h46.2V76.2H547.047V92.9h25.411v12.389H547.047V122.4h31.711V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.711,109.38V96.78H638.5v37.066a160.51,160.51,0,0,1-24.36,2.414q-16.7,0-22.942-8.925t-6.248-28.35q0-19.424,6.51-28.035t22.155-8.61a111,111,0,0,1,21.105,2.2l3.78.735-.42,11.236a199.209,199.209,0,0,0-20.632-1.366q-8.032,0-11.288,1.89t-4.777,6.982q-1.524,5.1-1.523,17.431t3.045,17.273q3.045,4.936,12.6,4.934l8.715-.42V109.38Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.54,111.061V135H650.05V63.6h27.721q25.2,0,25.2,23.519,0,13.966-10.5,20.58L702.655,135H686.8l-8.295-23.939Zm21.106-15.54a12.89,12.89,0,0,0,2.519-8.3,11.964,11.964,0,0,0-2.677-8.191q-2.678-3.043-7.717-3.045H664.54V98.67h13.44Q683.123,98.67,685.646,95.521Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.226,135l16.065-71.4H749.8L765.865,135h-14.49l-2.834-12.915H723.55L720.715,135Zm27.3-59.43-7.245,33.915h19.531L738.565,75.57Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.031,76.41V63.6h52.5V76.41h-18.9V135H782.141V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.564,135V63.6h14.49V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.9,127.388q-6.669,8.874-22.942,8.872t-22.943-8.872q-6.669-8.871-6.667-27.773t6.667-28.088q6.668-9.186,22.943-9.187T899.9,71.527q6.668,9.191,6.667,28.088T899.9,127.388Zm-34.545-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479T888.5,80.82q-3.149-5.88-11.549-5.88T865.4,80.82q-3.15,5.882-3.151,18.848T865.351,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.853,135V63.6h24.465l17.22,58.8h1.05V63.6h14.49V135H950.243l-17.85-58.8h-1.05V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.462,74.94q-11.445,0-11.445,7.56a5.726,5.726,0,0,0,2.835,5.146q2.835,1.785,13.283,5.144t14.647,7.612q4.2,4.252,4.2,13.074,0,11.237-6.824,17.009t-17.85,5.775a99.33,99.33,0,0,1-20.055-2.52l-3.78-.735,1.47-11.234a174.928,174.928,0,0,0,21.525,1.889q11.128,0,11.13-9.24a6.151,6.151,0,0,0-2.573-5.25q-2.573-1.89-10.237-4.095-12.181-3.463-17.167-8.242T983.632,83.55q0-10.71,6.51-15.96t17.85-5.25a118.717,118.717,0,0,1,19.74,2.1l3.78.735-1.155,11.445Q1015.552,74.942,1009.462,74.94Z",
    style: {
      fill: "#5e1513"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreachRiskCloudIntegrations);
export default __webpack_public_path__ + "static/media/BreachRisk_Cloud_Integrations.96285ce44360c169a352dd5cf6e4dac9.svg";
export { ForwardRef as ReactComponent };